import { render, staticRenderFns } from "./breadCrump.vue?vue&type=template&id=4b432121&scoped=true"
import script from "./breadCrump.vue?vue&type=script&lang=js"
export * from "./breadCrump.vue?vue&type=script&lang=js"
import style0 from "./breadCrump.vue?vue&type=style&index=0&id=4b432121&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b432121",
  null
  
)

export default component.exports